import type MenuItem from 'ui/src/data/MenuItem';
import {
  aPost,
  aPostConnection,
  aMenuConnection,
  anAcfOptionsBlogHomepageOptionsBloghomeoptions,
  aPostPostoptionsKeyQuestionsOptions,
} from '../gql/mocks';

const post = aPost();
const { nodes: postList } = aPostConnection();
const { nodes: menuList } = aMenuConnection();
const { featuredPost } = anAcfOptionsBlogHomepageOptionsBloghomeoptions();
const { keyQuestions } = aPostPostoptionsKeyQuestionsOptions();

export const newHeaderData = [
  {
    id: '1',
    title: 'Solutions',
    url: 'https://www.bairesdev.com/solutions/',
    sections: [
      {
        id: '1',
        title: 'Solutions',
        description:
          '<p>Get <a href="https://www.bairesdev.com/software-development-services/?nav=new">software development services</a>, built around your needs:</p>',
        links: [
          {
            id: '1068',
            link_label: 'Staff Augmentation',
            link_url: 'https://www.bairesdev.com/staff-augmentation/',
          },
          {
            id: '1069',
            link_label: 'Dedicated Teams',
            link_url: 'https://www.bairesdev.com/software-development-services/software-dedicated-team/',
          },
          {
            id: '1070',
            link_label: 'Software Outsourcing',
            link_url: 'https://www.bairesdev.com/software-development-services/software-outsourcing/',
          },
        ],
      },
      {
        id: '2',
        title: 'Top Solutions',
        description: null,
        links: [
          {
            id: '1071',
            link_label: 'AI Development',
            link_url: 'https://www.bairesdev.com/technologies/ai/',
          },
          {
            id: '1072',
            link_label: 'Android App Development',
            link_url: 'https://www.bairesdev.com/solutions/android/',
          },
          {
            id: '1073',
            link_label: 'Back-end Development',
            link_url: 'https://www.bairesdev.com/solutions/back-end/',
          },
          {
            id: '1074',
            link_label: 'Business Intelligence',
            link_url: 'https://www.bairesdev.com/solutions/bi/',
          },
          {
            id: '1075',
            link_label: 'CMS Development',
            link_url: 'https://www.bairesdev.com/solutions/cms/',
          },
          {
            id: '1076',
            link_label: 'Data Engineering',
            link_url: 'https://www.bairesdev.com/solutions/database/',
          },
          {
            id: '1077',
            link_label: 'Cryptocurrency & Blockchain',
            link_url: 'https://www.bairesdev.com/technologies/cryptocurrency/',
          },
          {
            id: '1078',
            link_label: 'eCommerce Development',
            link_url: 'https://www.bairesdev.com/solutions/ecommerce/',
          },
          {
            id: '1079',
            link_label: 'Front-end Development',
            link_url: 'https://www.bairesdev.com/solutions/front-end/',
          },
          {
            id: '1080',
            link_label: 'iOS App Development',
            link_url: 'https://www.bairesdev.com/solutions/ios/',
          },
          {
            id: '1081',
            link_label: 'Machine Learning',
            link_url: 'https://www.bairesdev.com/solutions/machine-learning/',
          },
          {
            id: '1082',
            link_label: 'Mobile App Development',
            link_url: 'https://www.bairesdev.com/solutions/mobile-app/',
          },
          {
            id: '1083',
            link_label: 'QA Testing & Automation',
            link_url: 'https://www.bairesdev.com/solutions/qa/',
          },
          {
            id: '1084',
            link_label: 'SaaS Development',
            link_url: 'https://www.bairesdev.com/solutions/saas/',
          },
          {
            id: '1085',
            link_label: 'UX/UI Design',
            link_url: 'https://www.bairesdev.com/solutions/ui-ux/',
          },
          {
            id: '1086',
            link_label: 'Web Development',
            link_url: 'https://www.bairesdev.com/solutions/web-development/',
          },
        ],
      },
      {
        id: '3',
        title: 'Enterprise Focused',
        description: null,
        links: [
          {
            id: '1087',
            link_label: 'Backup Solutions',
            link_url: 'https://www.bairesdev.com/solutions/backup/',
          },
          {
            id: '1088',
            link_label: 'Big Data',
            link_url: 'https://www.bairesdev.com/solutions/big-data/',
          },
          {
            id: '1089',
            link_label: 'Cloud Applications',
            link_url: 'https://www.bairesdev.com/solutions/cloud-application/',
          },
          {
            id: '1090',
            link_label: 'CRM Systems',
            link_url: 'https://www.bairesdev.com/solutions/crm/',
          },
          {
            id: '1091',
            link_label: 'Cybersecurity',
            link_url: 'https://www.bairesdev.com/solutions/cybersecurity/',
          },
          {
            id: '1092',
            link_label: 'DevOps',
            link_url: 'https://www.bairesdev.com/solutions/devops/',
          },
          {
            id: '1093',
            link_label: 'Digital Transformation',
            link_url: 'https://www.bairesdev.com/solutions/digital-transformation/',
          },
          {
            id: '1094',
            link_label: 'ERP Development',
            link_url: 'https://www.bairesdev.com/solutions/erp/',
          },
        ],
      },
    ],
    cta: {
      link_label: 'All Solutions',
      link_url: 'https://www.bairesdev.com/solutions/',
    },
    extraContent: {
      client: {
        data: {
          id: '4',
          attributes: {
            client_name: 'Rolls Royce',
            client_logos: {
              color_logo: {
                data: {
                  id: '738',
                  attributes: {
                    url: 'https://assets.bairesdev.com/image/upload/v1723133642/www/core/rolls_royce_default_6583f2d285.svg',
                  },
                },
              },
            },
          },
        },
      },
      image: {
        data: null,
      },
      content:
        '<p>We built an app for real-time nuclear plant monitoring. <a href="https://www.bairesdev.com/case-studies/rolls-royce/?nav=new">Read case study.</a></p>',
    },
  },
  {
    id: '2',
    title: 'Technologies',
    url: 'https://www.bairesdev.com/technologies/',
    sections: [
      {
        id: '4',
        title: 'Technologies',
        description: '<p>Get experts in 100+ technologies. Cover any tech stack.</p>',
        links: [
          {
            id: '1096',
            link_label: 'Hire Software Developers',
            link_url: 'https://www.bairesdev.com/hire-software-developers/',
          },
          {
            id: '1097',
            link_label: 'Top 1% Talent',
            link_url: 'https://www.bairesdev.com/top-1-percent/',
          },
        ],
      },
      {
        id: '5',
        title: null,
        description: null,
        links: [
          {
            id: '1098',
            link_label: '.NET',
            link_url: 'https://www.bairesdev.com/technologies/net/',
          },
          {
            id: '1099',
            link_label: 'Angular',
            link_url: 'https://www.bairesdev.com/technologies/angular/',
          },
          {
            id: '1100',
            link_label: 'AWS',
            link_url: 'https://www.bairesdev.com/technologies/aws/',
          },
          {
            id: '1101',
            link_label: 'C#',
            link_url: 'https://www.bairesdev.com/technologies/c-sharp/',
          },
          {
            id: '1102',
            link_label: 'C++',
            link_url: 'https://www.bairesdev.com/technologies/c-plus-plus/',
          },
          {
            id: '1103',
            link_label: 'Django',
            link_url: 'https://www.bairesdev.com/technologies/django/',
          },
          {
            id: '1104',
            link_label: 'Golang',
            link_url: 'https://www.bairesdev.com/technologies/go/',
          },
          {
            id: '1105',
            link_label: 'Google Cloud',
            link_url: 'https://www.bairesdev.com/technologies/google-cloud/',
          },
          {
            id: '1106',
            link_label: 'Java',
            link_url: 'https://www.bairesdev.com/technologies/java/',
          },
          {
            id: '1107',
            link_label: 'JavaScript',
            link_url: 'https://www.bairesdev.com/technologies/javascript/',
          },
          {
            id: '1108',
            link_label: 'Kotlin',
            link_url: 'https://www.bairesdev.com/technologies/kotlin/',
          },
          {
            id: '1109',
            link_label: 'Microsoft Azure',
            link_url: 'https://www.bairesdev.com/technologies/azure/',
          },
          {
            id: '1110',
            link_label: 'Node.js',
            link_url: 'https://www.bairesdev.com/technologies/nodejs/',
          },
          {
            id: '1111',
            link_label: 'Oracle',
            link_url: 'https://www.bairesdev.com/technologies/oracle/',
          },
          {
            id: '1112',
            link_label: 'PHP',
            link_url: 'https://www.bairesdev.com/technologies/php/',
          },
          {
            id: '1113',
            link_label: 'Power BI',
            link_url: 'https://www.bairesdev.com/technologies/power-bi/',
          },
          {
            id: '1114',
            link_label: 'Python',
            link_url: 'https://www.bairesdev.com/technologies/python/',
          },
          {
            id: '1115',
            link_label: 'React',
            link_url: 'https://www.bairesdev.com/technologies/react/',
          },
          {
            id: '1116',
            link_label: 'Ruby',
            link_url: 'https://www.bairesdev.com/technologies/ruby/',
          },
          {
            id: '1117',
            link_label: 'Salesforce',
            link_url: 'https://www.bairesdev.com/technologies/salesforce/',
          },
          {
            id: '1118',
            link_label: 'ServiceNow',
            link_url: 'https://www.bairesdev.com/technologies/servicenow/',
          },
          {
            id: '1119',
            link_label: 'TypeScript',
            link_url: 'https://www.bairesdev.com/technologies/typescript/',
          },
          {
            id: '1120',
            link_label: 'Vue.js',
            link_url: 'https://www.bairesdev.com/technologies/vue/',
          },
          {
            id: '1121',
            link_label: 'Xamarin',
            link_url: 'https://www.bairesdev.com/technologies/xamarin/',
          },
        ],
      },
    ],
    cta: {
      link_label: 'All Technologies',
      link_url: 'https://www.bairesdev.com/technologies/',
    },
    extraContent: {
      client: {
        data: {
          id: '5',
          attributes: {
            client_name: 'Pinterest',
            client_logos: {
              color_logo: {
                data: {
                  id: '825',
                  attributes: {
                    url: 'https://assets.bairesdev.com/image/upload/v1723133644/www/core/pinterest_default_152965998e.svg',
                  },
                },
              },
            },
          },
        },
      },
      image: {
        data: null,
      },
      content:
        '<p>We now have 230+ devs across 37 projects at Pinterest. <a href="https://www.bairesdev.com/case-studies/pinterest/?nav=new">Read case study.</a></p>',
    },
  },
  {
    id: '3',
    title: 'Industries',
    url: 'https://www.bairesdev.com/industries/',
    sections: [
      {
        id: '6',
        title: 'Industries',
        description:
          '<p>We’ve delivered 1250+ projects across 130+ sectors. Experience in your industry? We have it.</p>',
        links: [],
      },
      {
        id: '7',
        title: null,
        description: null,
        links: [
          {
            id: '1123',
            link_label: 'Agriculture',
            link_url: 'https://www.bairesdev.com/industries/agriculture/',
          },
          {
            id: '1124',
            link_label: 'Automotive',
            link_url: 'https://www.bairesdev.com/industries/automotive/',
          },
          {
            id: '1125',
            link_label: 'Aviation',
            link_url: 'https://www.bairesdev.com/industries/aviation/',
          },
          {
            id: '1126',
            link_label: 'Banking',
            link_url: 'https://www.bairesdev.com/industries/banking/',
          },
          {
            id: '1127',
            link_label: 'Construction',
            link_url: 'https://www.bairesdev.com/industries/construction/',
          },
          {
            id: '1128',
            link_label: 'Entertainment',
            link_url: 'https://www.bairesdev.com/industries/entertainment/',
          },
          {
            id: '1129',
            link_label: 'Finance',
            link_url: 'https://www.bairesdev.com/industries/finance/',
          },
          {
            id: '1130',
            link_label: 'Fintech',
            link_url: 'https://www.bairesdev.com/industries/fintech/',
          },
          {
            id: '1131',
            link_label: 'Healthcare',
            link_url: 'https://www.bairesdev.com/industries/healthcare/',
          },
          {
            id: '1132',
            link_label: 'Insurance',
            link_url: 'https://www.bairesdev.com/industries/insurance/',
          },
          {
            id: '1133',
            link_label: 'Martech',
            link_url: 'https://www.bairesdev.com/industries/martech/',
          },
          {
            id: '1134',
            link_label: 'Oil and Gas',
            link_url: 'https://www.bairesdev.com/industries/oil-gas/',
          },
          {
            id: '1135',
            link_label: 'Real Estate',
            link_url: 'https://www.bairesdev.com/industries/real-estate/',
          },
          {
            id: '1136',
            link_label: 'Retail',
            link_url: 'https://www.bairesdev.com/industries/retail/',
          },
          {
            id: '1137',
            link_label: 'Supply Chain',
            link_url: 'https://www.bairesdev.com/industries/supply-chain/',
          },
          {
            id: '1138',
            link_label: 'Telecommunications',
            link_url: 'https://www.bairesdev.com/industries/telecom/',
          },
          {
            id: '1139',
            link_label: 'Transportation and Logistics',
            link_url: 'https://www.bairesdev.com/industries/transportation-logistics/',
          },
          {
            id: '1140',
            link_label: 'Travel and Hospitality',
            link_url: 'https://www.bairesdev.com/industries/travel-hospitality/',
          },
        ],
      },
    ],
    cta: {
      link_label: 'All Industries',
      link_url: 'https://www.bairesdev.com/industries/',
    },
    extraContent: {
      client: {
        data: {
          id: '42',
          attributes: {
            client_name: 'IQVIA',
            client_logos: {
              color_logo: {
                data: {
                  id: '713',
                  attributes: {
                    url: 'https://assets.bairesdev.com/image/upload/v1723133641/www/core/iqvia_default_6fe9d143af.svg',
                  },
                },
              },
            },
          },
        },
      },
      image: {
        data: null,
      },
      content:
        '<p>We scaled IQVIA’s clinical research platforms with React. <a href="https://www.bairesdev.com/case-studies/iqvia/?nav=new">Read case study.</a></p>',
    },
  },
  {
    id: '4',
    title: 'About',
    url: 'https://www.bairesdev.com/about/',
    sections: [
      {
        id: '8',
        title: 'About',
        description:
          '<p>Since 2009, we’ve built software for companies of all types, from startups to Fortune 500 giants.</p>',
        links: [],
      },
      {
        id: '9',
        title: 'Inside BairesDev',
        description: null,
        links: [
          {
            id: '1142',
            link_label: 'Our Leadership Team',
            link_url: 'https://www.bairesdev.com/about/leadership-team/',
          },
          {
            id: '1143',
            link_label: 'Our Tech Talent',
            link_url: 'https://www.bairesdev.com/top-1-percent/',
          },
          {
            id: '1144',
            link_label: 'Press Releases',
            link_url: 'https://press.bairesdev.com/',
          },
          {
            id: '1145',
            link_label: 'Contact Us',
            link_url: 'https://www.bairesdev.com/contact-us/',
          },
        ],
      },
      {
        id: '10',
        title: 'Recognitions',
        description: null,
        links: [
          {
            id: '1146',
            link_label: 'Awards',
            link_url: 'https://www.bairesdev.com/awards-recognitions/',
          },
          {
            id: '1147',
            link_label: 'Certifications',
            link_url: 'https://www.bairesdev.com/about/certifications-and-partnerships/',
          },
        ],
      },
      {
        id: '11',
        title: 'Careers',
        description: '',
        links: [
          {
            id: '1148',
            link_label: 'Working at BairesDev',
            link_url: 'https://www.bairesdev.com/join-us/',
          },
          {
            id: '1149',
            link_label: 'Job Opportunities',
            link_url: 'https://talent.bairesdev.com/',
          },
          {
            id: '1150',
            link_label: 'Talent Referrals',
            link_url: 'https://www.bairesdev.com/referrals-program/',
          },
          {
            id: '1151',
            link_label: 'Our Circles Program',
            link_url: 'https://circles.bairesdev.com/',
          },
          {
            id: '1152',
            link_label: 'Company Culture',
            link_url: 'https://www.bairesdev.com/company-culture/',
          },
        ],
      },
    ],
    cta: {
      link_label: 'Our Story',
      link_url: 'https://www.bairesdev.com/about/',
    },
    extraContent: {
      client: {
        data: null,
      },
      image: {
        data: {
          attributes: {
            alternativeText: null,
            url: 'https://assets.bairesdev.com/image/upload/v1743020190/www/staging/nacho_816ff45aee.jpg',
          },
        },
      },
      content: '<p>Our CEO, speaking at the World Economic Forum at Davos 2025.</p>',
    },
  },
  {
    id: '5',
    title: 'Our Work',
    url: 'https://www.bairesdev.com/clients/',
    sections: [],
    cta: null,
    extraContent: null,
  },
  {
    id: '6',
    title: 'Blog',
    url: 'https://www.bairesdev.com/blog/',
    sections: [],
    cta: null,
    extraContent: null,
  },
];

export const deprecatedMenuData: MenuItem[] = [
  {
    id: 'megamenTempID',
    path: '/software-development-services/',
    label: 'Services',
    children: [
      {
        id: 'sdbsfrteqebwrt',
        path: 'https://www.bairesdev.com/software-development-services/',
        label: 'Software Development Services',
        description:
          'Nearshore your software development. <br> <a href="https://www.bairesdev.com/hire-software-developers/?nav=old">Hire software developers</a> through flexible engagement models:',
        children: [
          {
            id: 'cG9zdDo2MDkwMg==',
            path: '/staff-augmentation/',
            label: 'Staff Augmentation',
            description: 'Our software developers in your team.',
            icon: 'StaffAugmentation',
            children: [],
          },
          {
            id: 'cG9zdDafgo2fMDkwdMQ==',
            path: '/software-development-services/software-dedicated-team/',
            label: 'Dedicated Teams',
            description: 'Our software teams in your organization.',
            icon: 'DedicatedTeams',
            children: [],
          },
          {
            id: 'cG9zdDo2MDkwMw==',
            path: '/software-development-services/software-outsourcing/',
            label: 'Software Outsourcing',
            description: 'Our PM and software teams building for you.',
            icon: 'SoftwareOutsourcing',
            children: [],
          },
        ],
      },
      {
        id: 'wertwtytygfw',
        path: 'https://www.bairesdev.com/technologies/',
        label: 'Technologies',
        children: [
          {
            id: 'cG9zdDo2MdfsDkwMQ==',
            path: 'https://www.bairesdev.com/technologies/react/',
            label: 'React',
            children: [],
          },
          {
            id: 'cG9zdDo2sdfasdfMDkwMg==',
            path: 'https://www.bairesdev.com/technologies/nodejs/',
            label: 'Node.js',
            children: [],
          },
          {
            id: 'cG9zdDodfgsdfg2MDkwMw==',
            path: 'https://www.bairesdev.com/technologies/python/',
            label: 'Python',
            children: [],
          },
          {
            id: 'cG9zdDwerterto2MDkwMw==',
            path: 'https://www.bairesdev.com/technologies/net/',
            label: '.NET',
            children: [],
          },
          {
            id: 'cG9zdDo2ertyertMDkwMw==',
            path: 'https://www.bairesdev.com/technologies/java/',
            label: 'Java',
            children: [],
          },
          {
            id: 'cG9zdwerDo2MDkwMw==',
            path: 'https://www.bairesdev.com/technologies/ruby/',
            label: 'Ruby',
            children: [],
          },
          {
            id: 'cG9zdDo2MDkwrtwertMw==',
            path: 'https://www.bairesdev.com/technologies/php/',
            label: 'PHP',
            children: [],
          },
          {
            id: 'cG9qwerqwerzdDo2MDkwMw==',
            path: 'https://www.bairesdev.com/technologies/go/',
            label: 'Golang',
            children: [],
          },
          {
            id: 'cG9zdDo2MDkwwertwerMw==',
            path: 'https://www.bairesdev.com/technologies/angular/',
            label: 'Angular',
            children: [],
          },
        ],
      },
      {
        id: 'ccccergbvbfgcc',
        path: 'https://www.bairesdev.com/solutions/',
        label: 'Solutions',
        children: [
          {
            id: 'cG9zdDo2MasdfDkwMQ==',
            path: 'https://www.bairesdev.com/solutions/qa/',
            label: 'QA Testing & Automation',
            children: [],
          },
          {
            id: 'cG9zdDo2MDfgdkwMg==',
            path: 'https://www.bairesdev.com/solutions/bi/',
            label: 'Business Intelligence',
            children: [],
          },
          {
            id: 'cG9zdDoadfgr2MDkwMw==',
            path: 'https://www.bairesdev.com/solutions/data-science/',
            label: 'Data Science',
            children: [],
          },
          {
            id: 'cG9zdDo2MrtrethytrhDkwMQ==',
            path: 'https://www.bairesdev.com/solutions/ios/',
            label: 'iOS App Development',
            children: [],
          },
          {
            id: 'cG9zdDo2MDfdgdkwMg==',
            path: 'https://www.bairesdev.com/solutions/ui-ux/',
            label: 'UX/UI Design',
            children: [],
          },
          {
            id: 'cG9zdDo2asdfaMDkwMw==',
            path: 'https://www.bairesdev.com/solutions/android/',
            label: 'Android App Development',
            children: [],
          },
          {
            id: 'cG9zdDo2MDsdfgskwMQ==',
            path: 'https://www.bairesdev.com/solutions/machine-learning/',
            label: 'Machine Learning',
            children: [],
          },
          {
            id: 'cG9zasdfdDo2MDkwMg==',
            path: 'https://www.bairesdev.com/solutions/database/',
            label: 'Data Engineering',
            children: [],
          },
          {
            id: 'cG9zdDhjho2MDkwMw==',
            path: 'https://www.bairesdev.com/software-development-services/front-end/',
            label: 'Front-end Development',
            children: [],
          },
        ],
      },
      {
        id: 'ddddergbvbfgcc',
        path: '',
        label: 'Enterprise',
        children: [
          {
            id: 'dG9zdDo2MasdfDkwMQ==',
            path: 'https://www.bairesdev.com/technologies/servicenow/',
            label: 'ServiceNow',
            children: [],
          },
          {
            id: 'dG9zdDo2MDfgdkwMg==',
            path: 'https://www.bairesdev.com/technologies/salesforce/',
            label: 'Salesforce',
            children: [],
          },
          {
            id: 'dG9zdDoadfgr2MDkwMw==',
            path: 'https://www.bairesdev.com/technologies/oracle/',
            label: 'Oracle',
            children: [],
          },
          {
            id: 'dG9zdDo2MrtrethytrhDkwMQ==',
            path: 'https://www.bairesdev.com/technologies/aws/',
            label: 'AWS',
            children: [],
          },
          {
            id: 'dG9zdDo2MDfdgdkwMg==',
            path: 'https://www.bairesdev.com/technologies/google-cloud/',
            label: 'Google Cloud',
            children: [],
          },
          {
            id: 'dG9zdDo2asdfaMDkwMw==',
            path: 'https://www.bairesdev.com/technologies/coldfusion/',
            label: 'Adobe ColdFusion',
            children: [],
          },
          {
            id: 'dG9zdDo2MDsdfgskwMQ==',
            path: 'https://www.bairesdev.com/technologies/elasticsearch/',
            label: 'Elasticsearch',
            children: [],
          },
          {
            id: 'dG9zasdfdDo2MDkwMg==',
            path: 'https://www.bairesdev.com/solutions/cybersecurity/',
            label: 'Cybersecurity',
            children: [],
          },
          {
            id: 'dG9zdDhjho2MDkwMw==',
            path: 'https://www.bairesdev.com/solutions/ecommerce/',
            label: 'eCommerce',
            children: [],
          },
        ],
      },
    ],
  },
  {
    id: 'cG9zdDo2MDkwNA==',
    path: '/clients/',
    label: 'Our Clients',
    children: [],
  },
  {
    id: 'cG9zdDo2MDkxMQ==',
    path: '/about/',
    label: 'About Us',
    children: [
      {
        id: 'cG9zdDogfe5ewNw==',
        path: '/about/',
        label: 'About Us',
        description: 'Who we are and how our vision became reality.',
        children: [],
      },
      {
        id: 'cG9zdDo2MDkxNw==',
        path: '/about/leadership-team/',
        label: 'Our Leadership Team',
        description: 'Industry-recognized. Award-winning.',
        children: [],
      },
      {
        id: 'cG9zdDo2MDkxOA==',
        path: 'https://www.bairesdev.com/top-1-percent/',
        label: 'Top 1% Talent',
        children: [],
      },
      {
        id: 'cG9zdDo2MDkyMA==',
        path: '/awards-recognitions/',
        label: 'Recognitions',
        children: [],
      },
      {
        id: 'cG9zdDo2MDkyMQ==',
        path: 'https://www.bairesdev.com/diversity-inclusion/',
        label: 'Diversity & Inclusion',
        children: [],
      },
      {
        id: 'cG9zdDo2MDkyMg==',
        path: 'https://www.bairesdev.com/software-development-services/expertise/',
        label: 'Expertise',
        children: [],
      },
      {
        id: 'cG9zdDo2MDkyMR==',
        path: 'https://www.bairesdev.com/contact-us/',
        label: 'Contact Us',
        children: [],
      },
    ],
  },
  {
    id: 'cG9zdDo2MDkxMg==',
    path: '/blog/',
    label: 'Blog',
    children: [],
  },
  {
    id: 'cG9zdDo2MDkxMw==',
    path: 'https://www.bairesdev.com/join-us/',
    label: 'Careers',
    children: [
      {
        id: 'cG9zd353kh3DkxNQ==',
        path: 'https://www.bairesdev.com/join-us/',
        label: 'Careers',
        description: 'What is it like working at BairesDev?',
        children: [],
      },
      {
        id: 'cG9zdDo2MDkxNQ==',
        path: 'https://talent.bairesdev.com/',
        label: 'Job Opportunities',
        children: [],
      },
      {
        id: 'cG9zdDo2MDkxNg==',
        path: 'https://www.bairesdev.com/referrals-program/',
        label: 'Talent Referrals',
        children: [],
      },
    ],
  },
];

const mocks = {
  post,
  postList,
  menuList,
  featuredPost,
  keyQuestions,
};

export default mocks;
